import { Button } from '../../ui/Button';
import styles from './CTABand.module.css';

interface CTABandProps {
  eyebrow?: string;
  heading?: string;
  subheading?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export function CTABand({
  eyebrow = 'Ready to transform?',
  heading = 'Turn Your Data Into a Competitive Advantage',
  subheading = 'See how NAATS can accelerate your business with end-to-end data and AI solutions.',
  primaryLabel = 'Request a Demo',
  primaryTo = '/contact',
  secondaryLabel = 'Explore the Platform',
  secondaryTo = '/platform',
}: CTABandProps) {
  return (
    <div className={styles.band}>
      <div className={styles.inner}>
        <div className={styles.textGroup}>
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          <h2 className={styles.heading}>{heading}</h2>
          {subheading && <p className={styles.subheading}>{subheading}</p>}
        </div>
        <div className={styles.actions}>
          <Button to={primaryTo} variant="primary" size="lg">
            {primaryLabel}
          </Button>
          <Button to={secondaryTo} variant="outline-light" size="lg">
            {secondaryLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
